/**
 * Public PostHog config for the web build. The project token is PUBLIC by design (same US project 628117 as the
 * other Hustle apps, e.g. tv-remote-il app.config.ts); `VITE_POSTHOG_KEY` / `VITE_POSTHOG_HOST` override it.
 */
export const POSTHOG_PROJECT_TOKEN = 'phc_CCnnqheUcJRSNHzXiresCGb9BBxwjebKeqwGcs4S5TjB';
export const POSTHOG_HOST = 'https://us.i.posthog.com';

interface ViteEnv {
  VITE_POSTHOG_KEY?: string;
  VITE_POSTHOG_HOST?: string;
  VITE_APP_VERSION?: string;
  VITE_BUILD_ID?: string;
  DEV?: boolean;
}
const env = (): ViteEnv => (import.meta as unknown as { env?: ViteEnv }).env ?? {};

export const webAnalyticsConfig = (): {
  key: string;
  host: string;
  version: string;
  build: string;
  dev: boolean;
} => {
  const e = env();
  return {
    key: e.VITE_POSTHOG_KEY || POSTHOG_PROJECT_TOKEN,
    host: e.VITE_POSTHOG_HOST || POSTHOG_HOST,
    version: e.VITE_APP_VERSION || '0.1.0',
    build: e.VITE_BUILD_ID || 'web',
    dev: e.DEV === true,
  };
};

/** `?c=<campaign_token>` on the landing URL (share links), or null. */
export const campaignFromUrl = (): string | null => {
  try {
    return new URLSearchParams(globalThis.location?.search ?? '').get('c');
  } catch {
    return null;
  }
};
